import { Container } from 'inversify';
import { annotationModule } from './__legacy__/modules/annotation/annotation.module';
import { annotationTypeModule } from './__legacy__/modules/annotation/submodules/annotationTypes/annotationType.module';
import { clarificationsModule } from './__legacy__/modules/annotation/submodules/clarifications/Clarifications.module';
import { annotationReviewModule } from './__legacy__/modules/annotation/submodules/review/annotationReview.module';
import { reviewRejectReasonsModule } from './__legacy__/modules/annotation/submodules/reviewRejectReasones/reviewRejectReasons.module';
import { segmentationsModule } from './__legacy__/modules/annotation/submodules/segmentations/segmentationContextMenu/segmentations.module';
import { attachmentsModule } from './__legacy__/modules/attachments/attachments.module';
import { authModule } from './__legacy__/modules/auth/auth.module';
import { billingModule } from './__legacy__/modules/billing/billing.module';
import { datasetsModule } from './__legacy__/modules/datasets/datasets.module';
import { errorsModule } from './__legacy__/modules/errors/errors.module';
import { freeAccessModule } from './__legacy__/modules/freeAccess/freeAccess.module';
import { integrationModule } from './__legacy__/modules/integration/integrations.module';
import { notificationsModule } from './__legacy__/modules/notifications/notifications.module';
import { projectDetailsModule } from './__legacy__/modules/projectDetails/projectDetails.module';
import { projectsModule } from './__legacy__/modules/projects/projects.module';
import { teamModule } from './__legacy__/modules/team/team.module';
import { userModule } from './__legacy__/modules/user/user.module';
import { workspacesModule } from './__legacy__/modules/workspaces/workspaces.module';
import { servicesModule } from './__legacy__/services/services.module';
import { adminModule } from './modules/admin/admin.module';
import { alertBarModule } from './modules/alertBar/AlertBar.module';
import { renameAttachmentModule } from './modules/attachments/rename/RenameAttachment.module';
import { cloudCostsModule } from './modules/cloudCosts/cloudCosts.module';
import { commonModule } from './modules/common/Common.module';
import { cursorControlModule } from './modules/editor/cursorControl/CursorControl.module';
import { editorModule } from './modules/editor/Editor.module';
import { jobsModule } from './modules/jobs/jobs.module';
import { addMarkingToolModule } from './modules/projects/details/annotationTools/markingTools/add/AddMarkingTool.module';
import { markingToolsModule } from './modules/projects/details/annotationTools/markingTools/commons/MarkingTools.module';
import { editMarkingToolModule } from './modules/projects/details/annotationTools/markingTools/edit/EditMarkingTool.module';
import { exportDataModule } from './modules/projects/details/exportData/ExportData.module';
import { importAnnotationsModule } from './modules/projects/details/images/importAnnotations/importAnnotations.module';
import { projectStatisticsModule } from './modules/projects/details/stats/ProjectStatistics.module';
import { projectOverviewModule } from './modules/projects/project/overview/projectOverview.module';
import { sideNavigationModule } from './modules/sideNavigation/sideNavigation.module';
import { currentWorkspaceModule } from './modules/workspaces/currentWorkspace/CurrentWorkspace.module';

export const container = new Container();

container.load(
  annotationTypeModule,
  annotationReviewModule,
  annotationModule,
  segmentationsModule,
  reviewRejectReasonsModule,
  addMarkingToolModule,
  adminModule,
  alertBarModule,
  attachmentsModule,
  authModule,
  billingModule,
  clarificationsModule,
  cloudCostsModule,
  commonModule,
  currentWorkspaceModule,
  cursorControlModule,
  datasetsModule,
  editMarkingToolModule,
  editorModule,
  errorsModule,
  jobsModule,
  exportDataModule,
  freeAccessModule,
  importAnnotationsModule,
  integrationModule,
  markingToolsModule,
  notificationsModule,
  projectDetailsModule,
  projectOverviewModule,
  projectsModule,
  projectStatisticsModule,
  renameAttachmentModule,
  servicesModule,
  sideNavigationModule,
  teamModule,
  userModule,
  workspacesModule
);
